// Sandbox requests run on the agent machine: the backend queues them and the agent
// picks them up on its next poll, so a request can wait a while (agent offline).
export const ACTIVE_TASK_STATUSES = ["Pending", "Dispatched"];

export const TASK_POLL_INTERVAL = 10000;

export const isTaskActive = (task) => ACTIVE_TASK_STATUSES.includes(task?.status);

// Submitted, but none of its analyses finished yet, so there is no report to list.
export const isTaskAwaitingReports = (task) =>
  task?.status === "Completed" && !task?.completedReports;

// Whether the task may still change on the backend and is worth polling.
export const shouldPollTask = (task) => isTaskActive(task) || isTaskAwaitingReports(task);

const statusLabels = {
  Pending: "Waiting for agent",
  Dispatched: "Collecting file",
  Completed: "Submitted",
  Failed: "Failed",
  Expired: "Expired",
  Cancelled: "Cancelled",
};

export const getTaskStatusLabel = (task) => statusLabels[task?.status] || task?.status || "-";

const errorMessages = {
  FILE_NOT_FOUND: (task, withPath) =>
    withPath
      ? `The file no longer exists at ${task.filePath} (deleted, moved or renamed).`
      : "The file no longer exists at this path (deleted, moved or renamed).",
  HASH_MISMATCH: (task, withPath) =>
    withPath
      ? `The file at ${task.filePath} has changed since it was detected (hash differs), it was not submitted.`
      : "The file has changed since it was detected (hash differs), it was not submitted.",
  ACCESS_DENIED: () => "The agent could not read the file (access denied).",
  FILE_LOCKED: () => "The agent could not read the file, it is locked by another process.",
  TOO_LARGE: () => "The file is too large to be collected from the machine.",
  UPLOAD_FAILED: () => "The file could not be uploaded from the machine.",
  EXPIRED: () => "The agent did not come online within 7 days.",
};

// Human readable explanation of why a request did not go through. Pass
// `withPath: false` where the path is already shown next to the message.
export const getTaskErrorMessage = (task, { withPath = true } = {}) => {
  const message = errorMessages[task?.errorCode];
  return message ? message(task, withPath) : task?.errorMessage || "";
};
